import { useEffect } from 'react';

import { useSetAtom } from 'jotai';
import { OrbitControls } from 'three-stdlib';

import { playback3dCameraSphericalAtom, playback3dCameraTargetAtom } from '@store';

type UseCameraPersistence = {
    controls: OrbitControls;
    enablePan: boolean;
};

export function useCameraPersistence({ controls, enablePan }: UseCameraPersistence) {
    const setCameraSpherical = useSetAtom(playback3dCameraSphericalAtom);
    const setCameraTarget = useSetAtom(playback3dCameraTargetAtom);

    useEffect(() => {
        const persistCameraState = () => {
            setCameraSpherical({
                azimuthal: controls.getAzimuthalAngle(),
                polar: controls.getPolarAngle(),
                distance: controls.getDistance(),
            });
            if (enablePan && controls.target) {
                setCameraTarget(controls.target);
            }
        };

        controls.addEventListener('end', persistCameraState);

        return () => {
            persistCameraState();
            controls.removeEventListener('end', persistCameraState);
        };
    }, [controls, enablePan, setCameraSpherical, setCameraTarget]);
}
